module.exports = __webpack_public_path__ + "img/13.2.TN.481d7a7b.png";